module.exports = __webpack_public_path__ + "img/illus_insurance.fb80f1ff.svg";